import { IEnum } from "@interfaces/common.interfaces";


/*
*
*/
export const SharedObjectType: Array<IEnum> = [
    { id: 0, name: 'Unknown' },
    { id: 1, name: 'File' },
    { id: 2, name: 'Folder' },
    { id: 3, name: 'Item' },
    { id: 4, name: 'List' },
    { id: 5, name: 'Web' },
    { id: 6, name: 'Max' }
];

/*
*
*/
export const SharingType: Array<IEnum> = [
    { id: 0, name: 'Uninitialised' },
    { id: 1, name: 'Direct' },
    { id: 2, name: 'OrganisationView' },
    { id: 3, name: 'OrganisationEdit' },
    { id: 4, name: 'AnonymousView' },
    { id: 5, name: 'AnonymousEdit' },
    { id: 6, name: 'Flexible' }
];

/*
*
*/
export const SharingLinkPermissionsType: Array<IEnum> = [
    { id: 0, name: 'Edit' },
    { id: 1, name: 'Review' },
    { id: 2, name: 'Read' },
    { id: 3, name: 'ReadNoDownload' }
];

/*
*
*/
export const RemovalScope = {
    SpecificLink: 0,        // Remove specific sharing link from item
    AllLinksFromItem: 1,    // Remove all sharing links from specific item
    AllLinksFromWorkspace: 2 // Remove all sharing links from workspace
} as const;

export type RemovalScopeType = typeof RemovalScope[keyof typeof RemovalScope];

/*
 * File size unit for filtering
 */
export const FileSizeUnit = {
    MB: 0,
    GB: 1
} as const;

export type FileSizeUnitType = typeof FileSizeUnit[keyof typeof FileSizeUnit];

/*
 * Filter operator for combining filter criteria
 */
export const FilterOperator = {
    And: 0,
    Or: 1
} as const;

export type FilterOperatorType = typeof FilterOperator[keyof typeof FilterOperator];